import useMedias from '@Hooks/useMedias';
import useTranslation from '@Queries/useTranslation';
import GallerySection from '@Components/GallerySection';
import RibbleCard from './elems/RibbleCard';
import styles from './RibbleComposition.module.css';

import type { ModuleProductData } from '@Types/ModuleProduct';
import type { FC, HTMLAttributes } from 'react';

interface RibbleCompositionProps extends HTMLAttributes<HTMLDivElement> {
  modules: ModuleProductData[];
}

const RibbleComposition: FC<RibbleCompositionProps> = (props) => {
  const { modules, ...restProps } = props;
  const { isMobileM } = useMedias();
  const { t } = useTranslation();

  return (
    <GallerySection
      defaultGap
      inContainer={false}
      cnGallery={styles.gallery}
      cnSlide={styles.slide}
      title={t('ribble.composition.title')}
      scrollable={isMobileM}
      slides={modules}
      renderSlide={(module) => <RibbleCard module={module} />}
      data-testid='ribble-composition'
      {...restProps}
    />
  );
};

export default RibbleComposition;
